import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "../../ui/button";

interface TooltipActionProps {
  icon: ReactNode;
  label: string;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
  openInNewTab?: boolean;
}

const TooltipAction = ({
  icon,
  label,
  onClick,
  to,
  openInNewTab,
}: TooltipActionProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (openInNewTab && to) {
      window.open(to, "_blank", "noopener,noreferrer");
    } else if (onClick) {
      onClick(e);
    }
  };

  const content = (
    <>
      <div className="flex h-full items-center justify-start">{icon}</div>
      <div className="flex-grow text-left">
        <span className="text-xs font-medium">{label}</span>
      </div>
    </>
  );

  return to && !openInNewTab ? (
    <Link to={to} onClick={handleClick}>
      <Button
        variant="blueOutline"
        className="flex w-full items-center justify-between gap-2"
      >
        {content}
      </Button>
    </Link>
  ) : (
    <Button
      variant="blueOutline"
      className="flex w-full items-center justify-between gap-2"
      onClick={handleClick}
    >
      {content}
    </Button>
  );
};

export default TooltipAction;
